import { render, staticRenderFns } from "./CouponsRoute.vue?vue&type=template&id=61516397&scoped=true&"
import script from "./CouponsRoute.vue?vue&type=script&lang=js&"
export * from "./CouponsRoute.vue?vue&type=script&lang=js&"
import style0 from "./CouponsRoute.vue?vue&type=style&index=0&id=61516397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61516397",
  null
  
)

export default component.exports